export function createPage2Content(): string {
  return `<div>This is the content of page 2</div>`;
}
